import React, {Component} from "react";
import AirModal from "../../../../common/components/AirModal";
import {
  AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip,
} from 'recharts';
import {inject, observer} from "mobx-react";
import moment from "moment";

@inject('translationsStore')
@observer
class OverRpmsChart extends Component {
  render() {
    const { visible, onClose, trip } = this.props;

    let data = [];

    if(trip.endAt) {
      data= [
        { time: new Date(trip.startAt).getTime() },
        { time: new Date(trip.endAt).getTime() },
      ]
    }

    return (
      <AirModal
        visible={visible}
        onCancel={onClose}
        width="676px"
      >
        <AreaChart
          width={500}
          height={400}
          data={data}
          margin={{
            top: 10, right: 30, left: 0, bottom: 0,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis
            dataKey="time"
           domain = {['auto', 'auto']}
           name = 'Time'
           tickFormatter = {(unixTime) => moment(unixTime).utcOffset(0).format('HH:mm')}
           type = 'number'
          />
          <YAxis />
          <Tooltip />
          <Area type="monotone" dataKey="uv" stroke="#8884d8" fill="#8884d8" />
        </AreaChart>
      </AirModal>
    )
  }
}
export default OverRpmsChart;



// WEBPACK FOOTER //
// ./src/components/App/Trips/TripDetail/OverRpmsChart.js